import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class JobRoomUnlockedChatMessage extends AbstractChatMessage {
  type = MessageTypes.JOB_ROOM_UNLOCKED
  body: string = ''

  constructor(data: LX.JobRoomUnlockedChatMessage) {
    super(data)
    this.body =
      // eslint-disable-next-line max-len
      'Based on our discussion, I’m happy to utilise your services for this Job! Simply send through your offer and I will accept it so work can begin.'
  }

  static fromServer(data: LX.JobRoomUnlockedChatMessage) {
    return new JobRoomUnlockedChatMessage(data)
  }

  getShortMessage() {
    return this.body
  }
}
